angular.
module("dx.webapp.droparea").
directive("dxUploadarea", function uploadareaDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {
			uploadUrl: "<",
			formData: "<?",
			fileExtensions: "<",
			onFileUploaded: "<?",
			onCompleteAll: "<?",
			maxFiles: "<?",
			control: "=",
		},
		templateUrl: "tmpl/droparea/uploadarea-directive.html",
		transclude: true,
		controller: "DxUploadareaController",
		controllerAs: "vm",
		bindToController: true,
	};
});
